import { render } from "./PoliticasPrivacidad.vue?vue&type=template&id=53b6d622"
import script from "./PoliticasPrivacidad.vue?vue&type=script&lang=js"
export * from "./PoliticasPrivacidad.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__